module.exports = __webpack_public_path__ + "img/original.1d2ca11e.png";